import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { EncodeHttpParamsInterceptor } from './encode-http-params.interceptor';
import { ErrorHandlerInterceptor } from './error-handler.interceptor';
import { HttpCacheUrlInterceptor } from './http-cache-url.interceptor';
import { HttpRetryInterceptor } from './http-retry.interceptor';
import { InstanceInterceptor } from './instance.interceptor';
import { RefreshTokenInterceptor } from './refresh-token-interceptor.service';
import { SessionInterceptor } from './session.interceptor';
import { TrimBodyInterceptor } from './trim-body.interceptor';
import { UserInterceptor } from './user.interceptor';

const httpInterceptors = [
  HttpCacheUrlInterceptor,
  SessionInterceptor,
  RefreshTokenInterceptor,
  HttpRetryInterceptor,
  InstanceInterceptor,
  UserInterceptor,
  ErrorHandlerInterceptor,
  TrimBodyInterceptor,
  EncodeHttpParamsInterceptor,
] as const;

@NgModule()
export class HttpInterceptorsModule {
  static forRoot(): ModuleWithProviders<HttpInterceptorsModule> {
    return {
      ngModule: HttpInterceptorsModule,
      providers: [
        ...httpInterceptors.map((interceptor) => ({
          provide: HTTP_INTERCEPTORS,
          useClass: interceptor,
          multi: true,
        })),
      ],
    };
  }
}
